// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimActivityPostingDto
 */
export interface IClaimActivityPostingDto {
    /**
     * 
     * @type {string}
     * @memberof IClaimActivityPostingDto
     */
    plan_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IClaimActivityPostingDto
     */
    amount?: number;
    /**
     * 
     * @type {Date}
     * @memberof IClaimActivityPostingDto
     */
    transaction_at?: Date;
    /**
     * 
     * @type {number}
     * @memberof IClaimActivityPostingDto
     */
    account_id?: number;
}

/**
 * Check if a given object implements the IClaimActivityPostingDto interface.
 */
export function instanceOfIClaimActivityPostingDto(value: object): value is IClaimActivityPostingDto {
    return true;
}

export function IClaimActivityPostingDtoFromJSON(json: any): IClaimActivityPostingDto {
    return IClaimActivityPostingDtoFromJSONTyped(json, false);
}

export function IClaimActivityPostingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimActivityPostingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'transaction_at': json['transaction_at'] == null ? undefined : (new Date(json['transaction_at'])),
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
    };
}

export function IClaimActivityPostingDtoToJSON(json: any): IClaimActivityPostingDto {
    return IClaimActivityPostingDtoToJSONTyped(json, false);
}

export function IClaimActivityPostingDtoToJSONTyped(value?: IClaimActivityPostingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_name': value['plan_name'],
        'amount': value['amount'],
        'transaction_at': value['transaction_at'] == null ? undefined : ((value['transaction_at']).toISOString()),
        'account_id': value['account_id'],
    };
}

